// composables/useRegisterUser.ts
import { useRegisterUserMutation } from '@/types/vue-apollo-helpers';
import { useToast } from 'primevue/usetoast';
import type { UserRegisterInput } from '@/types/composition-functions';

export function useRegisterUser() {
  const { mutate, loading, error, onDone } = useRegisterUserMutation();
  const user = ref(null);
  const token = ref<string | null>(null);
  const router = useRouter();

  const toast = useToast();

  // Errors propagate to the caller, which shows them next to the right field.
  // (This used to swallow every failure into a generic "Error in registration"
  // toast, so the page never learned the email was already registered.)
  const registerUser = async(input: UserRegisterInput) => {
    const { data } = (await mutate({ input }))!;

    if (data?.registerUser) {
      router.push('/admin/home');
      toast.add({ severity: 'success', summary: 'Account created', detail: 'Welcome to Gradeverse!', life: 3000 });
      return data.registerUser;
    }

    return data;
  };

  return {
    registerUser,
    user,
    token,
    loading,
    error,
    onDone,
  };
}
